<script>
    /**
     * Wrapper for Vue-ChartJS, providing fully automated dynamic line graph support for the data set named in the prop
     *
     *
     */

    // Import the application event bus so we can listen for data changes and react accordingly
    import EventBus from '../../../eventBus';

    // Import Vue-ChartJS to perform the rendering for us
    import VueCharts from 'vue-chartjs';
    import { Line } from 'vue-chartjs';


    export default{
        extends:    Line,
        props:      ['datasource', 'title', 'sectionindex', 'viewid', 'config', 'content'],
        data:       function() {
            return {
                data:       {},
                metaData:   {},
                page:       {},
                report:     {},
                loaded:     false,
            }
        },

        methods:    {
            /**
             * Request VueChartJS re-render the chart
             */
            updateView: function(){
                // Overwriting base render method with actual data
                this.renderChart({
                    labels:                  this.getLabels(),
                    datasets: [
                        {
                            label:           this.metaData.title,
                            backgroundColor: '#C1CD23',
                            data:            this.getValues()
                        }
                    ]
                },
                { responsive: true, maintainAspectRatio: false }
                )
            },

            getLabels: function(){
                var labels = [];
                var self = this;
                this.data.data.forEach(function(record){
                    labels.push(record[self.config.fieldNameA]);
                });
                return labels;
            },

            getValues: function(){
                var values = [];
                var self = this;
                this.data.data.forEach(function(record){
                    values.push(record[self.config.fieldNameB]);
                });
                return values;
            }
        },


        /**
         * Tasks to perform once the Vue component has been constructed and page load event is fired
         *
         */
        mounted () {
            // Load initial data set
            this.data.data = this.content;
            this.updateView();
        },

        /**
         * Tasks to perform when data variables are changed.  This cannot be done by computed properties in this case because we need to call a function
         * to perform the re-render within the parent VueChartJS component
         */
        watch:{
            /**
             * If the main data set is updated then redraw the graph
             */
            data: function(){
                this.updateView();
            }
        },
}
</script>
